<template>
    <div id="banner">
        <div id="home" class="ancla"></div>
        <video loop autoplay muted v-if="lang == 'eng'">
            <source src="../assets/videos/Pantallas_eng2.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <video loop autoplay muted v-else-if="lang == 'esp'">
            <source src="../assets/videos/Pantallas_esp2.mp4" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="banner"></div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    img{
        width: 100%;
    }
    .banner{
        background-image: url('../assets/img/img_video.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 350px;
        display: none;
    }
    video{
        width: 100%;
    }
    @media screen and (max-width: 767px){
        video{
            display: none;
        }
        .banner{
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue